module.exports = __webpack_public_path__ + "static/img/icon_Scan@2x.c582d736.png";